export default __webpack_public_path__ + "static/media/autocad-2018-logo-brandlogos.net_daa2e8ebk.0fa98db5.svg";